import { BaseModal } from './BaseModal'
import { SettingsToggle } from './SettingsToggle'
import {
  DARK_MODE_DESCRIPTION,
  DARK_MODE_NAME,
  HARD_MODE_DESCRIPTION,
  HARD_MODE_NAME,
  HIGH_CONTRAST_MODE_DESCRIPTION,
  HIGH_CONTRAST_MODE_NAME,
  MATORAN_MODE_DESCRIPTION,
  MATORAN_MODE_NAME,
  SETTINGS_TITLE,
} from '../../constants/strings'

type Props = {
  isOpen: boolean
  handleClose: () => void
  isHardMode: boolean
  handleHardMode: Function
  isDarkMode: boolean
  handleDarkMode: Function
  isHighContrastMode: boolean
  handleHighContrastMode: Function
  isMatoranFontMode: boolean
  handleMatoranFontMode: Function
}

export const SettingsModal = ({
  isOpen,
  handleClose,
  isHardMode,
  handleHardMode,
  isDarkMode,
  handleDarkMode,
  isHighContrastMode,
  handleHighContrastMode,
  isMatoranFontMode,
  handleMatoranFontMode,
}: Props) => {
  return (
    <BaseModal title={SETTINGS_TITLE} isOpen={isOpen} handleClose={handleClose}>
      <div className="flex flex-col mt-2 divide-y">
        <SettingsToggle
          settingName={HARD_MODE_NAME}
          flag={isHardMode}
          handleFlag={handleHardMode}
          description={HARD_MODE_DESCRIPTION}
        />
        <SettingsToggle
          settingName={DARK_MODE_NAME}
          flag={isDarkMode}
          handleFlag={handleDarkMode}
          description={DARK_MODE_DESCRIPTION}
        />
        <SettingsToggle
          settingName={HIGH_CONTRAST_MODE_NAME}
          flag={isHighContrastMode}
          handleFlag={handleHighContrastMode}
          description={HIGH_CONTRAST_MODE_DESCRIPTION}
        />
        <SettingsToggle
          settingName={MATORAN_MODE_NAME}
          flag={isMatoranFontMode}
          handleFlag={handleMatoranFontMode}
          description={MATORAN_MODE_DESCRIPTION}
        />
      </div>
    </BaseModal>
  )
}
